'use strict';

let defaultPolicy = 'CANXSELF';

const definition = require('./tracking.definition');

const getAllNotTrackedElementsToTrack = () => $(`[data-${definition.TRACK_ACTION}]:not([data-${definition.TRACKED}])`);

const registerElement = (element, callback) => isElementToTrack(element) && registerElementTrack(element, callback);

const registerElementTrack = (element, callback) => {
    setAsTracked(element);
    bindElementTap(element, callback);
};

const bindElementTap = (element, callback) => {
    element.on('tap', () => {
        callback(getTapEvent(element));
    });
};

const replacePlacerholders = (targetValue) => {
    return replacePolicyPlaceholder(targetValue, defaultPolicy);
};

const replacePolicyPlaceholder = (targetValue, policy) => targetValue.replace(definition.validPlaceholders.policy, policy);

const getTapEvent = (element) => ({flow: getFlow(element), label: getFlowEvent(element)});

const setAsTracked = (element) => element.attr(`data-${definition.TRACKED}`, true);

const getFlow = (element) => element.data(definition.TRACK_ACTION) || '';

const isEventDefined = (element) => getFlowEvent(element).length > 0;

const getFlowEvent = function(element) {
    return replacePlacerholders(element.data(definition.TRACK_ID)) || '';
};

const isValidFlow = (flow) => Object.prototype.hasOwnProperty.call(definition.validFlows, flow);

const isElementToTrack = (element) => isEventDefinitionCorrect(element) && !isElementTracked(element);

const isEventDefinitionCorrect = (element) => isValidFlow(getFlow(element)) && isEventDefined(element);

const isElementTracked = (element) => element.data(definition.TRACKED) || false;

module.exports = {
    load(callback = (() => {}), policy) {
        if (policy) {
            defaultPolicy = policy;
        }
        getAllNotTrackedElementsToTrack().each((_, element) => {
            registerElement($(element), callback);
        });
    },
};
